import { ReactNode, useEffect } from 'react'

type Props = {
  open: boolean
  title?: string
  width?: number | string
  onClose: () => void
  footer?: ReactNode
  children: ReactNode
}

export default function Drawer({ open, title, width = 640, onClose, footer, children }: Props) {
  useEffect(() => {
    function onEsc(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose()
    }
    if (open) document.addEventListener('keydown', onEsc)
    return () => document.removeEventListener('keydown', onEsc)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[60]">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      {/* Panel */}
      <div
        className="absolute right-0 top-0 h-full bg-white shadow-xl flex flex-col"
        style={{ width }}
        role="dialog"
        aria-modal="true"
      >
        <div className="px-4 py-3 border-b border-[color:var(--border)] flex items-center justify-between">
          <div className="font-semibold">{title}</div>
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
        <div className="p-4 overflow-auto flex-1">{children}</div>
        {footer && (
          <div className="px-4 py-3 border-t border-[color:var(--border)]">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}
